import styled from "styled-components";

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SwitchWrapper = styled.div`
  margin-bottom: 16px;

  > div {
    width: auto;
    justify-content: flex-start;
  }
`;

export const InputWrapper = styled.div`
  margin-bottom: 16px;
`;
